module.exports = __webpack_public_path__ + "static/media/AD13_Background.e47d9397.jpg";